/**
 * Helper to get the name of a language based on its code in any language
 * @param language Code of the language to translate
 * @param locale Optional locale code to translate the name to
 * @returns The translated language name
 */
export function languageName(language: string, locale?: string) {
  const displayName = new Intl.DisplayNames(locale || language, {
    type: 'language'
  });

  const ln = displayName.of(language);
  return ln?.charAt(0).toUpperCase() + ln!.slice(1);
}
